<div class="contact__us my-14 flex justify-between gap-10">
  <div class="contact__content flex flex-col gap-4">
    <h2 translate="Contact Us"></h2>
    <h3 translate="We'd Love to Hear From You"></h3>
    <p
      translate="Whether you have a question, need support, or want to give feedback, we're
    here to help. Reach out to us anytime!"
    ></p>

    <div class="contact__social flex gap-4 mt-2">
      <!-- <a href="javascript:void">
        <div inlineSVG="contact-us/sms.svg"></div>
      </a> -->
      <a
        href="https://www.facebook.com/Posty5App"
        [attr.aria-label]="'Facebook Page' | translate | async"
      >
        <div inlineSVG="contact-us/facebook.svg"></div>
      </a>
      <a
        href="https://www.youtube.com/@posty5"
        [attr.aria-label]="'YouTube Channel' | translate | async"
      >
        <div inlineSVG="contact-us/youtube.svg"></div>
      </a>
    </div>
  </div>

  <div class="contact__form flex justify-end">
    <form class="flex flex-col gap-5" [formGroup]="form" (ngSubmit)="submit()">
      <p
        class="font-semibold text-[1.5rem] text-white text-center"
        translate="Send Us Now"
      ></p>

      <input-text
        [options]="{
          label: 'Your Name',
          control: form.controls.name,
          isShowErrors: isShowErrors(),
        }"
      ></input-text>
      <input-select
        [options]="{
          label: 'Subject',
          control: form.controls.type,
          isShowErrors: isShowErrors(),
          items: contactUsTopicList,
          searchable: false,
        }"
      ></input-select>
      <input-text
        [options]="{
          label: 'Your Email',
          control: form.controls.email,
          isShowErrors: isShowErrors(),
        }"
      ></input-text>
      <input-textarea
        [options]="{
          label: 'Your Message',
          control: form.controls.message,
          isShowErrors: isShowErrors(),
        }"
      ></input-textarea>

      @if (form.valid) {
        <div class="flex justify-center">
          <input-recaptcha
            [options]="{
              control: form.controls.recaptcha,
              isShowErrors: isShowErrors(),
            }"
          ></input-recaptcha>
        </div>
      }
      <button class="primary__btn" type="submit" name="submit" translate>
        Send
      </button>
    </form>
  </div>
</div>
